<template>
  <path
    d="M7 3.00018C6.45 3.00018 6 3.45018 6 4.00018V9.00018C6 11.9702 8.16 14.4302 11 14.9102V19.0002H9C8.45 19.0002 8 19.4502 8 20.0002C8 20.5502 8.45 21.0002 9 21.0002H15C15.55 21.0002 16 20.5502 16 20.0002C16 19.4502 15.55 19.0002 15 19.0002H13V14.9102C15.84 14.4302 18 11.9702 18 9.00018V4.00018C18 3.45018 17.55 3.00018 17 3.00018H7ZM16 8.00018H8V5.00018H16V8.00018Z"
  />
</template>
